import * as React from "react";
import styled from "styled-components";
import BodySmall from "../typography/BodySmall";
import { HorizontalSpacer } from "../Spacers";
import { theme } from "../../../theme";
import { useTranslation } from "react-i18next";
import Small from "../typography/Small";

const SelectStyle = styled.select`
  width: 100%;
  border: none;
  border-bottom: 1.25px solid ${theme.colors.grey40};
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.textSecondary};
  padding: 8px;
  background-color: ${theme.colors.white};
  min-width: 200px;
  height: 36px;

  &:focus {
    border-bottom: 1.25px solid ${theme.colors.text};
    color: ${theme.colors.text};
    outline: none;
  }
`;

interface Props {
  label?: string;
  value?: string;
  errorMessage?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  options: { value: string | undefined; label: string }[];
}

const Select: React.FC<Props> = ({
  label,
  value,
  errorMessage,
  onChange,
  disabled,
  options,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <Small
        color={disabled ? theme.colors.disabled : theme.colors.textSecondary}
      >
        {label}
      </Small>
      <HorizontalSpacer spacing={0.25} />
      {disabled ? (
        <BodySmall>{value}</BodySmall>
      ) : (
        <SelectStyle onChange={(e) => onChange(e.target.value)} value={value}>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {t(option.label)}
            </option>
          ))}
        </SelectStyle>
      )}
      {errorMessage && (
        <BodySmall color={theme.colors.error}>{errorMessage}</BodySmall>
      )}
    </div>
  );
};

export default Select;
